import { Utils } from '../../../../../../../core/utils/utils';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { Setvalues } from '../../../../../../../core/entities/setvalues.model';
import { SetvaluesService } from '../../../../../../../core/repositories/setvalues.service'

@Injectable()
export class EditDialogsSetValuesService {

  setvalues: Setvalues = new Setvalues();
  originalSetvalues: Setvalues = new Setvalues();
  parametersInput: Setvalues = new Setvalues();

  allSetvalues: Setvalues[] = [];
  changetitulo: boolean = false;
  opcion: boolean = false;

  constructor(private setvaluesService: SetvaluesService) { }

  /**
  * Inicia el dialog
  * @param data Datos recibidos por el dialog
  */
  init(data: any): Observable<boolean> {
    this.opcion = data.opcion;
    this.setvalues = data.setvalues;
    this.changetitulo = data.titulochange;
    this.originalSetvalues = _.cloneDeep(this.setvalues);
    console.log(data);
    return this.setvaluesService.findAll().pipe(map((result: Setvalues[]) => {
      this.allSetvalues = result;
      if (Utils.noUndfAndNull(data.setvalues)) {
        this.setvalues = _.cloneDeep(data.setvalues);
      }
      return true;
    }));
  }


  /**
  * @description
  * Guarda el setvalue
  */
  public guardar(): Observable<any> {
    console.log('guardar');
    if (Utils.noUndfAndNull(this.setvalues.id, "")) {

      /*comparamos el parametro original con el modificado*/
      let compareSetvalue = this.compare(this.setvalues, this.originalSetvalues);

      if(compareSetvalue){
        return of(-1);
      }else{
        return this.setvaluesService.postSetvalue(this.setvalues);
      }

    }else{
      return this.setvaluesService.postSetvalue(this.setvalues);
    }
  }

  /**
  * @description
  * Comprueba si dos Setvalues son iguales.
  * @param datoX Setvalue 1
  * @param datoY Setvalue 2
  * @returns True si son iguales
  */
  public compare(itemX:Setvalues, itemY:Setvalues):boolean {
    //Ambos objetos están definidos y no son nulos
    if (Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY)) {

      if(itemY.id == null){
        if (itemX.code !== "")
          return false;
      }else{
        if ((!Utils.compareTextOrNumber(itemX.code, itemY.code)
        || !Utils.compareTextOrNumber(itemX.descrip, itemY.descrip)
        || !Utils.compareTextOrNumber(itemX.numorder, itemY.numorder)
        || !Utils.compareTextOrNumber(itemX.cat, itemY.cat)
        || !Utils.compareTextOrNumber(itemX.esp, itemY.esp)
        || !Utils.compareTextOrNumber(itemX.ciutada_cat, itemY.ciutada_cat)
        || !Utils.compareTextOrNumber(itemX.ciutada_esp, itemY.ciutada_esp)
        || !Utils.compareTextOrNumber(itemX.empresa_cat, itemY.empresa_cat)
        || !Utils.compareTextOrNumber(itemX.empresa_esp, itemY.empresa_esp)
        || !Utils.compareTextOrNumber(itemX.proveidor_cat, itemY.proveidor_cat)
        || !Utils.compareTextOrNumber(itemX.proveidor_esp, itemY.proveidor_esp)
        ) && (itemX.code !== ""))
          return false;
      }
    }
    //Uno de los objetos no está definido o es nulo mientras el otro sí está definido
    else if ((Utils.noUndfAndNull(itemX) && !Utils.noUndfAndNull(itemY)) || (!Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY))) {
      return false;
    }
    return true;
  }

  /**
  * @description
  * Asigna a las propiedades del servicio sus valores por defecto
  */
  build() {
    this.setvalues = new Setvalues();
  }

}
